import { useState, useEffect } from "react"
import { Modal } from "components"
import axios from "axios"
import { useAuth } from "contexts/auth-context"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import Label from "components/forms/label"
import Input from "components/forms/input"
import ErrorMessage from "components/forms/error-message"

const Content = ({ data, success }) => {
    const { user } = useAuth()
    const [pin, setPin] = useState("")
    const [errors, setErrors] = useState({})

    useEffect(() => {
        setPin("")
        setErrors({})
    }, [data?.id])

    const handleSubmit = (e) => {
        e.preventDefault()
        nProgress.start()
        setErrors({})

        axios
            .post(`${process.env.REACT_APP_GENERIC_API_URL}/cashiers/${data.id}/reset-pin`, {
                pin: pin ?? "",
                updated_by: user?.name ?? "",
            })
            .then((response) => {
                success()
                toast.success(response.data.message)
            })
            .catch((error) => {
                if (error?.response?.status === 422) {
                    setErrors(error.response.data.errors || {})
                }

                toast.error(error?.response?.data?.message || "Request failed")
                console.log(error)
            })
            .finally(() => {
                nProgress.done()
            })
    }

    return (
        <form onSubmit={handleSubmit} className="mt-8 space-y-8">
            <div className="space-y-4">
                <div className="text-sm text-neutral-700">
                    Reset PIN untuk{" "}
                    <span className="inline-flex px-3 py-1 text-sm font-medium rounded-xl bg-neutral-200 text-neutral-600">
                        {data.name}
                    </span>
                </div>

                <div>
                    <Label htmlFor="pin" value="New PIN" />
                    <Input
                        id="pin"
                        value={pin}
                        onChange={(e) => setPin(e.target.value)}
                        error={errors.pin}
                        type="password"
                        placeholder="Enter 6-digit PIN"
                        inputMode="numeric"
                        maxLength={6}
                    />
                    <ErrorMessage error={errors.pin} />
                </div>
            </div>

            <div className="text-xs">
                <button
                    type="submit"
                    className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90"
                >
                    <span>Reset PIN</span>
                </button>
            </div>
        </form>
    )
}

const ResetPin = ({ data, onSuccess }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSuccess = () => {
        closeModal()
        onSuccess()
    }

    return (
        <>
            <button
                onClick={openModal}
                className="inline-flex items-center p-1 text-white transition bg-amber-600 rounded-full active:hover:scale-90"
                title="Reset PIN"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    strokeWidth={1}
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M12 17v4"></path>
                    <path d="M10 20l4 0"></path>
                    <path d="M6 10v-2a6 6 0 1 1 12 0v2"></path>
                    <rect x="5" y="10" width="14" height="7" rx="2"></rect>
                </svg>
            </button>

            <Modal
                isOpen={isOpen}
                onClose={closeModal}
                title="Reset PIN Cashier"
                content={<Content data={data} success={handleSuccess} />}
            />
        </>
    )
}

export default ResetPin